var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"mobile-game-selector"},_vm._l((_vm.games),function(game){return _c('li',{key:("mgs-" + (game.code)),attrs:{"role":"button"},on:{"click":function($event){_vm.$router.push({
        name: 'InstantMatchCatalogMobile',
        params: {
          gameCode: game.code.toLowerCase(),
          region: _vm.region
        }
      })}}},[_c('img',{attrs:{"src":game.banner}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }